<div class="gauge-chart-container">
   <canvas id="gaugeChart"></canvas>
   <div class="needle"></div>
   <span class="guage-label d-block py-1 px-2 label-1">Strong <br> Sell</span>
   <span class="guage-label d-block py-1 px-2 label-2">Sell</span>
   <span class="guage-label d-block py-1 px-2 label-3">Hold</span>
   <span class="guage-label d-block py-1 px-2 label-4">Buy</span>
   <span class="guage-label d-block py-1 px-2 label-5">Strong <br> Buy</span>
</div>
